// React import
import React from 'react';
import {bindActionCreators} from "redux";
import {hideNotification, showNotification} from "../../actions";
import {connect} from "react-redux";
// Styles imports
import './TokenAnalyzerWalletStatsItem.css';
import '../../util.css'
// Svg icons import
import { ReactComponent as EthSvg } from '../../svg-icons/coins/eth.svg';
import { ReactComponent as BaseSvg } from '../../svg-icons/coins/base.svg';
import { ReactComponent as BSCSvg } from '../../svg-icons/blockchains/binance-smart-chain.svg';
import { ReactComponent as TrendUpSvg } from '../../svg-icons/token-status/trend-up.svg';
import { ReactComponent as TrendDownSvg } from '../../svg-icons/token-status/trend-down.svg';
import { ReactComponent as TrendPumpSvg } from '../../svg-icons/token-status/trend-pump.svg';
import { ReactComponent as TrendDumpSvg } from '../../svg-icons/token-status/trend-dump.svg';
import { ReactComponent as TrendNoSvg } from '../../svg-icons/token-status/trend-no.svg';
import { ReactComponent as CopySvg } from '../../svg-icons/copy.svg';
// Consts imports
import {
    RED,
    ORANGE,
    YELLOW,
    EMERALD,
    GREEN,
    LEVEL_FEATURES,
    TOKEN_ANALYZER_WALLET_STATS,
    ETH_BLOCKCHAIN,
    ETH,
    BASE,
    BASE_BLOCKCHAIN,
    BSC,
    BSC_BLOCKCHAIN
} from "../../consts/consts";

async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

class Title extends React.Component {

    constructor(props) {
        super(props);
    }

    setNotification = () => {
        const { showNotification, hideNotification } = this.props;
        const duration = 750;
        showNotification({message: "Wallet address copied", duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    handleClick = async () => {
        const { address } = this.props;
        await copyTextToClipboard(address);
        this.setNotification();
    };

    render() {

        const {shortAddress, index, blockchain} = this.props;

        let blockchainName = ETH_BLOCKCHAIN;
        let iconComponent=(<EthSvg className={"token-analyzer__token-stats-item__token-icon"}/>);
        if (blockchain === ETH) {
            blockchainName = ETH_BLOCKCHAIN;
            iconComponent=(<EthSvg className={"token-analyzer__token-stats-item__token-icon"}/>);
        } else if (blockchain === BASE) {
            blockchainName = BASE_BLOCKCHAIN;
            iconComponent=(<BaseSvg className={"token-analyzer__token-stats-item__token-icon"}/>);
        } else if (blockchain === BSC) {
            blockchainName = BSC_BLOCKCHAIN;
            iconComponent=(<BSCSvg className={"token-analyzer__token-stats-item__token-icon"}/>);
        }
        blockchainName = blockchainName.toLowerCase();

        return (
            <div className={"token-analyzer__token-stats-item__token_title"}>
                {iconComponent}
                <div className={"token-analyzer__token_stats__token-title-description"}>
                    <span className={"token-analyzer__token-stats-item__token-index"}>
                        {index + 1}{"."}
                    </span>
                    <span className={"token-analyzer__token-stats-item__token-symbol"}>
                        {shortAddress}
                    </span>
                    <span className={"token-analyzer__token-stats-item__token-name"}>

                    </span>
                    <div className={"token-analyzer__token_stats-item__copy-icon-block"} onClick={this.handleClick}>
                        <CopySvg className={"token-analyzer__token_stats-item__copy-icon"}/>
                    </div>
                </div>
            </div>
        );
    }
}


function Indicator(props) {

    const {indicator} = props;

    let indicatorStyle = ""

    if (indicator === RED) {
        indicatorStyle = "token-analyzer__token-stats-item__item-indicator_red"
    } else if (indicator === ORANGE) {
        indicatorStyle = "token-analyzer__token-stats-item__item-indicator_orange"
    } else if (indicator === YELLOW) {
        indicatorStyle = "token-analyzer__token-stats-item__item-indicator_yellow"
    } else if (indicator === EMERALD) {
        indicatorStyle = "token-analyzer__token-stats-item__item-indicator_emerald"
    } else if (indicator === GREEN) {
        indicatorStyle = "token-analyzer__token-stats-item__item-indicator_green"
    } else {
        return null
    }

    return (
        <div className={"token-analyzer__token-stats-item__item-indicator " + indicatorStyle}></div>
    );

}

function Icon(props) {

    const {indicator} = props;

    let icon;

    if (indicator === GREEN) {
        icon = (<TrendPumpSvg className={"token-analyzer__token-stats-item__status-icon token-analyzer__token_stats-item__status-icon_green"}/>);
    } else if (indicator === EMERALD) {
        icon = (<TrendUpSvg className={"token-analyzer__token-stats-item__status-icon token-analyzer__token_stats-item__status-icon_emerald"}/>);
    } else if (indicator === YELLOW) {
        icon = (<TrendNoSvg className={"token-analyzer__token-stats-item__status-icon token-analyzer__token_stats-item__status-icon_yellow"}/>);
    } else if (indicator === ORANGE) {
        icon = (<TrendDownSvg className={"token-analyzer__token-stats-item__status-icon token-analyzer__token_stats-item__status-icon_orange"}/>);
    } else if (indicator === RED) {
        icon = (<TrendDumpSvg className={"token-analyzer__token-stats-item__status-icon token-analyzer__token_stats-item__status-icon_red"}/>);
    } else {
        return null
    }

    return (
        <div className={"token-analyzer__token-stats-item__status-icon-block"}>
            {icon}
        </div>
    )

}

function Stats(props) {
    const { bought, sold, profit, pnl, firstTx, lastTx, tradeTime, buys, sells, aiLevel} = props;

    if (aiLevel < LEVEL_FEATURES[TOKEN_ANALYZER_WALLET_STATS]) {
        return (
            <div className={"token-analyzer__token-stats-item__token-stats"}>
            <span className={"token-analyzer__token-stats-item__token-stats-text"}>
                Bought: {bought}$<br/>Sold: {sold}$<br/><br/>

                First TX: AI level 5<br/>Trade time: AI level 5
            </span>
                <span className={"token-analyzer__token-stats-item__token-stats-text"}>
                <span className={"token-analyzer__token-stats-item__token-stats-text-bold"}>
                    Profit: {profit}$<br/>PnL: AI level 5
                </span>
                <br/><br/>Buys: AI level 5<br/>Sells: AI level 5
            </span>
            </div>
        );
    } else {
        return (
            <div className={"token-analyzer__token-stats-item__token-stats"}>
            <span className={"token-analyzer__token-stats-item__token-stats-text"}>
                Bought: {bought}$<br/>Sold: {sold}$<br/><br/>
                First TX: {firstTx}<br/>Trade time: {tradeTime}
            </span>
                <span className={"token-analyzer__token-stats-item__token-stats-text"}>
                <span className={"token-analyzer__token-stats-item__token-stats-text-bold"}>
                    Profit: {profit}$<br/>PnL: {pnl}%
                </span>
                <br/><br/>Buys: {buys}<br/>Sells: {sells}
            </span>
            </div>
        );
    }

}

class TokenAnalyzerWalletStatsItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { address, shortAddress, indicator, bought,  sold, profit, pnl,
            firstTx, tradeTime, buys, sells, index, aiLevel } = this.props;
        const { showNotification, hideNotification } = this.props;
        const { blockchain } = this.props.blockchain;
        let aiLevelInt = parseInt(aiLevel);

        return (
            <div className={"token-analyzer__token-stats-item"}>
                <Indicator indicator={indicator}/>
                <Title index={index} shortAddress={shortAddress} address={address}
                       showNotification={showNotification} hideNotification={hideNotification}
                       blockchain={blockchain}/>
                <Stats bought={bought} sold={sold}
                       profit={profit} pnl={pnl}
                       firstTx={firstTx} tradeTime={tradeTime}
                       buys={buys} sells={sells} aiLevel={aiLevelInt}/>
                <Icon indicator={indicator}/>
            </div>
        );
    }

}


const mapStateToProps = ({checkWallet, notification, blockchain}) => {
    return {checkWallet, notification, blockchain};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenAnalyzerWalletStatsItem);